import { Session } from 'next-auth';
import { apiService } from '@/lib/services/api.service';
import { API_CONFIG } from '@/lib/config/api.config';
import { User } from '@/lib/models/client.types';

class UserService {
  async updateLanguage(userId: string, language: string, session: Session) {
    return apiService.patch<User>(
      API_CONFIG.ENDPOINTS.USERS.UPDATE(userId),
      { language },
      session
    );
  }

  async getUser(userId: string, session: Session) {
    return apiService.get<User>(API_CONFIG.ENDPOINTS.USERS.BASE, session);
  }

  async updateUser(userId: string, data: Partial<User>, session: Session) {
    return apiService.patch<User>(
      API_CONFIG.ENDPOINTS.USERS.UPDATE(userId),
      data,
      session
    );
  }

  async deleteAccount(userId: string, session: Session) {
    // TODO
    // return apiService.delete(API_CONFIG.ENDPOINTS.USERS.BASE, session);
    return true;
  }

  async deleteConversationHistory(userId: string, session: Session) {
    // TODO
    // return apiService.delete(API_CONFIG.ENDPOINTS.CONVERSATIONS.BASE, session);
    return true;
  }
}

export const userService = new UserService();
